import {
  AppBar,
  Box,
  Button,
  IconButton,
  List,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import Drawer from "@mui/material/Drawer";
import { Link, useNavigate } from "react-router-dom";
import WanderobeLogo from "../../assets/images/wanderobe-logo-1.svg";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import { StyledHeader, StyledDrawer } from "./StyledHeader";
import { ROUTE_PATH } from "../../constants/route";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { fetchLogout } from "../../store/reducers/authentication/apiThunk";
import { BorderButton } from "../../components/CommonComponents/Button";

const Header = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [authenticationLogin, setAuthenticationLogin] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authentication = useSelector((state) => state.authentication);
  const [anchorEl, setAnchorEl] = useState(null);
  const profile = useSelector((state) => state?.createProfile?.userProfile);

  const toggleDrawer = (open) => {
    setDrawerOpen(open);
  };

  useEffect(() => {
    const auth_token =
      authentication?.auth?.data?.auth_token ||
      authentication?.auth?.data?.data?.auth_token ||
      authentication?.userData?.data?.auth_token ||
      "";
    if (auth_token) {
      setAuthenticationLogin(true);
    } else {
      setAuthenticationLogin(false);
    }
  }, [authentication]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100;
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
    }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <StyledHeader>
        <AppBar className='appbar'>
          <Toolbar className='toolbar'>
            {isDrawerOpen ? (
              ""
            ) : (
              <IconButton
                aria-label='hamberger'
                className='hanberger-icon'
                onClick={() => toggleDrawer(true)}
                edge='end'
              >
                <MenuIcon />
              </IconButton>
            )}
            <Link to={ROUTE_PATH.DASHBOARD} aria-label='home-logo'>
              <Box
                component='img'
                className='logo'
                loading='lazy'
                src={WanderobeLogo}
                alt='logo'
                sx={{ transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.1)'
                  }}}
              />
            </Link>
            <Box className='header-right-section'>
              {authenticationLogin ? (
                <Box>
                  <Box className='profile-button' onClick={handleMenuOpen}>
                    <PersonOutlineRoundedIcon className='icon-background' />
                    <Typography className='userName'>Profile</Typography>
                    <KeyboardArrowDownRoundedIcon className='icon-background' />
                  </Box>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    PaperProps={{
                      className: "dropdownMenu",
                    }}
                  >
                    <MenuItem
                      className='dropDownRow1'
                      onClick={handleMenuClose}
                    >
                      <Box className='profile-image'>
                        <img
                          src={profile?.brand_image}
                          alt='aa'
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      </Box>
                      <Box>
                        <Typography className='dorpDownUserName'>
                          {(profile?.seller_name || "username")?.length > 20
                            ? `${(profile?.seller_name || "username")?.slice(0, 20)}...`
                            : profile?.seller_name || "username"}
                        </Typography>
                        <Typography
                          className='dorpDownViewProfile'
                          onClick={() => navigate(ROUTE_PATH.EDIT_PROFILE)}
                        >
                          View Profile
                        </Typography>
                      </Box>
                    </MenuItem>
                    <MenuItem classetOpenLogoutModalsName='dropDownRow2'>
                      <BorderButton
                        onClick={() => {
                          setAnchorEl(null);
                          dispatch(fetchLogout());
                        }}
                      >
                        Logout
                      </BorderButton>
                    </MenuItem>
                  </Menu>
                </Box>
              ) : (
                <>
                  <Box className='header-links'>
                    <Link
                      className='link-text'
                      aria-label='aboutUs'
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(ROUTE_PATH.DASHBOARD);

                        setTimeout(() => {
                          scrollToSection("wanderobeSection");
                        }, 100);
                      }}
                    >
                      About Us
                    </Link>
                    <Link
                      className='link-text'
                      aria-label='howItWorks'
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(ROUTE_PATH.DASHBOARD);

                        setTimeout(() => {
                          scrollToSection("how-it-works");
                        }, 100);
                      }}
                    >
                      How it works
                    </Link>
                  </Box>
                  <Box className='header-btns'>
                    <Button
                      varient='outlined'
                      className='signup-btn'
                      onClick={() => navigate(ROUTE_PATH.SIGNUP)}
                    >
                      Sign Up
                    </Button>
                    <Button
                      varient='contained'
                      color='primary'
                      className='login-btn'
                      onClick={() => navigate(ROUTE_PATH.LOGIN)}
                    >
                      Login
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          </Toolbar>
        </AppBar>
      </StyledHeader>
      <StyledDrawer>
        <Drawer
          anchor='left'
          open={isDrawerOpen}
          onClose={() => toggleDrawer(false)}
        >
          <Box
            className='mobile-layout'
            role='presentation'
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              height: "100vh",
            }}
          >
            <List
              className='drawer-item-list'
              sx={{ width: "100vw", display: "flex", flexDirection: "column" }}
            >
              <Box
                className='drawer-header'
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  padding: "20px 0px",
                  marginBottom: "20px",
                }}
              >
                <Button
                  className='iconClass'
                  onClick={() => toggleDrawer(false)}
                  variant='text'
                  sx={{ position: "absolute", left: "0" }}
                >
                  <CloseIcon />
                </Button>
                <Link
                  onClick={() => toggleDrawer(false)}
                  aria-label='home-logo'
                >
                  <img
                    className='logo'
                    src={WanderobeLogo}
                    alt='logo'
                    loading='lazy'
                    style={{ height: "20px" }}
                  />
                </Link>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  padding: "0px 20px",
                }}
              >
                <Box
                  sx={{
                    border: "0.8px solid #CBCBCB",
                    margin: "0px 0px 10px 0px",
                  }}
                ></Box>
                <Link
                  onClick={() => {
                    toggleDrawer(false);
                    scrollToSection("wanderobeSection");
                  }}
                  className='drawerLinks'
                >
                  <Typography
                    sx={{
                      fontWeight: "500",
                      fontSize: "12px",
                      lineHeight: "18px",
                      color: "black",
                    }}
                  >
                    ABOUT US
                  </Typography>
                </Link>
                <Link
                  onClick={() => {
                    toggleDrawer(false);
                    scrollToSection("how-it-works");
                  }}
                  className='drawerLinks'
                >
                  <Typography
                    sx={{
                      fontWeight: "500",
                      fontSize: "12px",
                      lineHeight: "18px",
                      color: "black",
                      textDecoration: "none",
                    }}
                  >
                    HOW IT WORKS
                  </Typography>
                </Link>
                <Link
                  onClick={() => toggleDrawer(false)}
                  className='drawerLinks'
                >
                  <Typography
                    sx={{
                      fontWeight: "500",
                      fontSize: "12px",
                      lineHeight: "18px",
                      color: "black",
                    }}
                  >
                    HELP & SUPPORT
                  </Typography>
                </Link>
                <Box
                  sx={{
                    border: "0.8px solid #CBCBCB",
                    margin: "10px 0px 0px 0px",
                  }}
                ></Box>
              </Box>
            </List>
            {authenticationLogin ? (
              <Box sx={{ padding: "0px 20px" }}>
                <Button
                  varient='contained'
                  color='primary'
                  onClick={() => {
                    dispatch(fetchLogout());
                    toggleDrawer(false);
                  }}
                  sx={{
                    width: "100%",
                    border: `1px solid black`,
                    borderRadius: "0px",
                    padding: "9px 20px",
                    fontFamily: "Lexend",
                    textTransform: "none",
                  }}
                >
                  Logout
                </Button>
              </Box>
            ) : (
              <>
                <Box sx={{ padding: "0px 20px" }}>
                  <Box
                    sx={{ display: "flex", gap: "10px", alignItems: "center" }}
                  >
                    <AccountCircleOutlinedIcon sx={{ fontSize: "30px" }} />
                    <Typography
                      sx={{
                        fontWeight: "400",
                        fontSize: "16px",
                        lineHeight: "20px",
                      }}
                    >
                      Create Your Wanderobe Account
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        color: "#656565",
                        fontWeight: "300",
                        fontSize: "12px",
                        lineHeight: "18px",
                      }}
                    >
                      Join us to showcase your brand and grow your business!
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    padding: "0px 20px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <Button
                    varient='contained'
                    color='primary'
                    onClick={() => {
                      navigate(ROUTE_PATH.LOGIN);
                      toggleDrawer(false);
                    }}
                    sx={{
                      width: "100%",
                      backgroundColor: "black",
                      color: "white",
                      borderRadius: "0px",
                      padding: "10px 20px",
                      fontFamily: "Lexend",
                      textTransform: "none",
                    }}
                  >
                    Login
                  </Button>
                  <Button
                    varient='contained'
                    color='primary'
                    onClick={() => {
                      toggleDrawer(false);
                      navigate(ROUTE_PATH.SIGNUP);
                    }}
                    sx={{
                      width: "100%",
                      border: `1px solid black`,
                      borderRadius: "0px",
                      padding: "9px 20px",
                      fontFamily: "Lexend",
                      textTransform: "none",
                    }}
                  >
                    Signup
                  </Button>
                </Box>
              </>
            )}
          </Box>
        </Drawer>
      </StyledDrawer>
    </>
  );
};

export default Header;
